var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import { DropdownOption } from '../../definitions/formItem/ElementConfig';
// import * as OptionTypeFactory from '../optionType/optionType';
var ProductListItem = /** @class */ (function () {
    function ProductListItem(obj, id) {
        var _a;
        if (id) {
            this.id = id;
        }
        this.name = (_a = obj.name) !== null && _a !== void 0 ? _a : obj.product_name;
        this.price = obj.price;
        this.status = obj.status;
        this.positionCat = obj.position;
    }
    Object.defineProperty(ProductListItem.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductListItem.prototype, "Position", {
        get: function () {
            return this.positionCat;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductListItem.prototype, "Name", {
        get: function () {
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductListItem.prototype, "Price", {
        get: function () {
            return this.price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductListItem.prototype, "Status", {
        get: function () {
            return this.status;
        },
        set: function (status) {
            this.status = status;
        },
        enumerable: false,
        configurable: true
    });
    return ProductListItem;
}());
export { ProductListItem };
var Product = /** @class */ (function (_super) {
    __extends(Product, _super);
    function Product(obj, id) {
        var _this = _super.call(this, obj, id) || this;
        _this.bg_name = obj.bg_name;
        _this.en_name = obj.en_name;
        _this.slug = obj.slug;
        _this.bg_description = obj.bg_description;
        _this.en_description = obj.en_description;
        _this.line_name = obj.line_name;
        _this.bg_subhead = obj.bg_subhead;
        _this.en_subhead = obj.en_subhead;
        _this.bg_usage = obj.bg_usage;
        _this.en_usage = obj.en_usage;
        _this.bg_pao = obj.bg_pao;
        _this.en_pao = obj.en_pao;
        // this.composition = obj.composition;
        _this.bg_manufacturer_information = obj.bg_manufacturer_information;
        _this.en_manufacturer_information = obj.en_manufacturer_information;
        _this.bg_features = obj.bg_features;
        _this.en_features = obj.en_features;
        _this.youtube_url = obj.youtube_url;
        _this.position = obj.position;
        _this.promotion_percent_difference = obj.promotion_percent_difference;
        _this.option_type_id = _.get(obj, 'option_type.id', _.get(obj, 'option_type'));
        _this.brand_id = _.get(obj, 'brand.id', _.get(obj, 'brand'));
        _this.brands_formatted = obj.brand
            ? new DropdownOption({
                label: _.get(obj, 'brand.attributes.name'),
                value: _.get(obj, 'brand.id'),
            })
            : null;
        // used only for formatting to dropdown option so it can be loaded in the control instantly
        _this.category_ids = _this.getCategoriesIds(obj.categories);
        _this.categories_formatted = _this.getCategoriesFormatted(obj.categories);
        _this.brand_category_ids = _this.getBrandCategoriesIds(obj.brand_categories);
        _this.brand_categories_formatted = _this.getBrandCategoriesFormatted(obj.brand_categories);
        _this.label = _.get(obj, 'label', null);
        /* this.brand_categories = this.getCategoriesIds(obj.brand_categories);
        this.brand_categories_formatted = this.getCategoriesFormatted(obj.brand_categories); */
        _this.bg_seo_description = obj.bg_seo_description;
        _this.en_seo_description = obj.en_seo_description;
        _this.meta_title = obj.meta_title;
        _this.meta_description = obj.meta_description;
        return _this;
    }
    Product.prototype.getCategoriesIds = function (rawCategories) {
        var categoriesIds = [];
        for (var _i = 0, rawCategories_1 = rawCategories; _i < rawCategories_1.length; _i++) {
            var cat = rawCategories_1[_i];
            categoriesIds.push(Number(cat.value));
        }
        return categoriesIds;
    };
    Product.prototype.getCategoriesFormatted = function (rawCategories) {
        var categoriesIds = [];
        for (var _i = 0, rawCategories_2 = rawCategories; _i < rawCategories_2.length; _i++) {
            var cat = rawCategories_2[_i];
            categoriesIds.push(new DropdownOption({
                label: _.get(cat, 'attributes.bg_name') + " (" + _.get(cat, 'attributes.slug') + ")",
                value: _.get(cat, 'id'),
            }));
        }
        return categoriesIds;
    };
    Product.prototype.getBrandCategoriesIds = function (rawCategories) {
        var categoriesIds = [];
        for (var _i = 0, rawCategories_3 = rawCategories; _i < rawCategories_3.length; _i++) {
            var cat = rawCategories_3[_i];
            categoriesIds.push(Number(cat.value));
        }
        return categoriesIds;
    };
    Product.prototype.getBrandCategoriesFormatted = function (rawCategories) {
        var categoriesIds = [];
        for (var _i = 0, rawCategories_4 = rawCategories; _i < rawCategories_4.length; _i++) {
            var cat = rawCategories_4[_i];
            categoriesIds.push(new DropdownOption({
                label: _.get(cat, 'attributes.bg_name') + " (" + _.get(cat, 'attributes.slug') + ")",
                value: _.get(cat, 'id'),
            }));
        }
        return categoriesIds;
    };
    Object.defineProperty(Product.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "Slug", {
        get: function () {
            return this.slug;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BgDescription", {
        get: function () {
            return this.bg_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "EnDescription", {
        get: function () {
            return this.en_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "LineName", {
        get: function () {
            return this.line_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BgSubhead", {
        get: function () {
            return this.bg_subhead;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "EnSubhead", {
        get: function () {
            return this.en_subhead;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BgUsage", {
        get: function () {
            return this.bg_usage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "EnUsage", {
        get: function () {
            return this.en_usage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BgPao", {
        get: function () {
            return this.bg_pao;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "EnPao", {
        get: function () {
            return this.en_pao;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BrandsFormatted", {
        get: function () {
            return this.brands_formatted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BgManufacturer", {
        // public get Composition(): string | null {
        //     return this.composition;
        // }
        get: function () {
            return this.bg_manufacturer_information;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "EnManufacturer", {
        get: function () {
            return this.en_manufacturer_information;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BgFeatures", {
        get: function () {
            return this.bg_features;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "EnFeatures", {
        get: function () {
            return this.en_features;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "YouTubeUrl", {
        get: function () {
            return this.youtube_url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "OptionType", {
        get: function () {
            return this.option_type_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "Brand", {
        get: function () {
            return this.brand_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BrandFormatted", {
        get: function () {
            return this.brand_categories_formatted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "Categories", {
        get: function () {
            return this.category_ids;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BrandCategories", {
        get: function () {
            return this.brand_category_ids;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "CategoriesFormatted", {
        get: function () {
            return this.categories_formatted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BrandCategoriesFormatted", {
        get: function () {
            return this.brand_categories_formatted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "ProductLabel", {
        get: function () {
            return this.label;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "PromotionPercentDifference", {
        get: function () {
            return this.promotion_percent_difference;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "BgDescriptionSEO", {
        get: function () {
            return this.bg_seo_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "EnDescriptionSEO", {
        get: function () {
            return this.en_seo_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "MetaTitle", {
        get: function () {
            return this.meta_title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "MetaDescription", {
        get: function () {
            return this.meta_description;
        },
        enumerable: false,
        configurable: true
    });
    return Product;
}(ProductListItem));
export { Product };
export function createProductListItem(obj, id) {
    return new ProductListItem(obj, id);
}
export function createProduct(obj, id) {
    return new Product(obj, id);
}
export function createProducts(rawProducts) {
    var products = [];
    var rawProductsData = rawProducts.data;
    for (var _i = 0, rawProductsData_1 = rawProductsData; _i < rawProductsData_1.length; _i++) {
        var rawProduct = rawProductsData_1[_i];
        var product = createProductListItem(rawProduct.attributes, rawProduct.id);
        products.push(product);
    }
    return products;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/product/product.ts
// module id = 43
// module chunks = 0